// Per-loop metadata the session document doesn't carry: each loop's length
// and key, from /api/loop?id=<hash>. Fetched on demand (the session's base
// loop for the stats line, every loop when Play all starts, one loop when its
// menu opens), cached for the page's life, and reactive so a row or a stat
// fills in when its answer lands.
import { reactive } from "vue";
import { keyName } from "@/kit/musicKey.js";

const API = process.env.VUE_APP_API_URL || "";

// hash -> { duration (seconds, 0 when unknown), key ("F♯m", "" when unknown) }
const meta = reactive({});
const pending = new Set();

export function loopMeta(hash) {
  return (hash && meta[hash]) || null;
}

export function loadLoopMeta(hashes) {
  for (const hash of hashes || []) {
    if (!hash || meta[hash] || pending.has(hash)) continue;
    pending.add(hash);
    fetch(`${API}/api/loop?id=${encodeURIComponent(hash)}`)
      .then((r) => (r.ok ? r.json() : null))
      .then((body) => {
        const r = body?.data?.results;
        if (!r) return;
        const d = Number(r.duration);
        meta[hash] = {
          duration: isFinite(d) && d > 0 ? d : 0,
          // The one key spelling (musicKey.js), as the pack page and the
          // buy sheet print it.
          key: keyName(r.key_pitch_class, r.key_is_minor) || "",
        };
      })
      .catch(() => {
        /* best effort: the stat and the playheads simply stay out */
      })
      .finally(() => pending.delete(hash));
  }
}

// "4.0 s", as the boards write a loop's length.
export function formatLength(seconds) {
  return seconds > 0 ? `${seconds.toFixed(1)} s` : "";
}
